import { Table, TableCell, TableRow } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import '../../custom.css'

const TableStyled = withStyles({
  root: {
    borderSpacing: '0px 5px',
    borderCollapse: 'separate',
    padding: '15px'
  }
})(Table);

const TableRowStyled = withStyles({
  root: {
     transform: 'scale(1)',
     boxShadow: '0px 2px 5px rgba(0,0,0,0.2) !important'
  }
})(TableRow);

const TableCellStyled = withStyles({
  root: {
     padding: "5px"
  }
})(TableCell);

const TableRowHeaderStyled = withStyles({
  root: {
    background: "var(--custom-header-secondary-color)"
  }
})(TableRow);

const TableRowTypographyHeaderStyled = withStyles({
  root: {
    fontFamily: 'PT Sans',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: '19px',
    letterSpacing: '-0.02em',
    color: '#FFFFFF'
  }
})(Typography);

const TableRowTypographyContentStyled = withStyles({
  root: {
    fontFamily: 'PT Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '15px',
    lineHeight: '19px',
    letterSpacing: '-0.02em'
  }
})(Typography);


export { TableCellStyled, TableRowStyled, TableStyled,TableRowHeaderStyled, TableRowTypographyHeaderStyled, TableRowTypographyContentStyled }


// WEBPACK FOOTER //
// ./src/components/common/TableStyled.js